import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20flowing%20gradient%20curves%20in%20deep%20red%20and%20dark%20charcoal%20tones%2C%20dramatic%20lighting%20with%20soft%20glow%20center%2C%20luxurious%20theater%20vibe%2C%20cinematic%20atmosphere%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20smooth%20gradients&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="51影视 - 免费高清影视在线观看"
        title="51影视网 - 免费影视在线观看不缓冲"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white text-center leading-tight mb-4">
          免费影视<span className="text-primary-400">高清不卡顿</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 text-center max-w-2xl mb-8 leading-relaxed">
          海量视频免费看，不缓冲流畅体验。热播剧集、科幻大片、动作巨制、高分佳作，一网打尽
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-play-circle-line mr-2"></i>立即观影
          </Link>
          <Link
            to="/category/高分佳作"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-white/20"
          >
            <i className="ri-star-line mr-2"></i>高分佳作
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-black text-white">20000+</p>
            <p className="text-xs text-white/60 mt-1">影视资源</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-black text-primary-400">99.9%</p>
            <p className="text-xs text-white/60 mt-1">流畅播放率</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-black text-white">500万+</p>
            <p className="text-xs text-white/60 mt-1">活跃用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}